import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-3 has-cursor-pointer block" }
const _hoisted_2 = ["name", "value"]
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dynamic_image = _resolveComponent("dynamic-image")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.options, (option) => {
    return (_openBlock(), _createElementBlock("div", {
      key: option.uuid,
      class: "mb-2"
    }, [
      _createElementVNode("label", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          name: _ctx.question.uuid,
          value: option.uuid,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAnswers) = $event))
        }, null, 8, _hoisted_2), [
          [_vModelRadio, _ctx.selectedAnswers]
        ]),
        _createTextVNode(" " + _toDisplayString(option.text), 1)
      ]),
      (option.image)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_dynamic_image, {
              image: option.image
            }, null, 8, ["image"])
          ]))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}